<app-page-wrapper>
  <app-loading-spinner *ngIf="!organization;else main_content"></app-loading-spinner>

  <ng-template #main_content>
    <app-onboarding-notification-modal [orgId]="organization.ID"></app-onboarding-notification-modal>
    <!-- <app-organization-license-summary #settingsModal [activeLicenses]="activeLicenses" [orgSalesRep]="orgSalesRep" [organizationId]="organizationId"></app-organization-license-summary> -->
    <div class="my-4">
      <a *ngIf="organization.ParentOrganizationID && organization.IsParentOrganizationVisibleToAccount"
        routerLink="/organizations/{{ organization.ParentOrganizationID }}" class="breadcrumb-link">
        <i class="far fa-angle-left"></i>
        {{ organization.ParentOrganizationDescription }}
      </a>
    </div>

    <div class="header my-4">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-end">
          <h1 class="m-0 mr-2">
            <ng-container *ngIf="editObj">
              {{ organization.ID && 'Edit' || 'Add' }} Organization
            </ng-container>
            <ng-container *ngIf="!editObj">
              {{ organization.Description }}
            </ng-container>
          </h1>
          <!-- <div *ngIf="!editObj" class="badge badge-primary mr-2 mb-1">{{ getOrganizationType(organization) }}</div> -->
          <span *ngIf="!editObj && organization.ExternalID && organization.IsCleverOrg" class="grey-text-color">#{{
            organization.ExternalID }}</span>
        </div>
        <div class="d-flex">
            <!-- <span (click)="$event.preventDefault(); $event.stopPropagation(); organizationSettings()" *ngIf="organizationId !== undefined && organizationId !== null && isInternal()"
                ngbTooltip="Settings" class="ml-4">
              <img src="assets/icon-setting.png" class="custom-icon ml-4 icon-spacing">
          </span> -->
          <app-eeu-report-modal *ngIf="isSuper()" [orgID]="organizationId"></app-eeu-report-modal>
          <app-print-qr-codes *ngIf="!organization.IsCleverOrg && classesFullList && classesFullList.length > 0"
            [orgId]="organizationId"></app-print-qr-codes>
          <span *ngIf="organization.IsValidClientSyncTarget" routerLink="/organizations/{{ organizationId }}/import"
            ngbTooltip="Upload roster">
            <img src="assets/icon-upload-template.svg" class="custom-icon ml-4">
          </span>
          <span *ngIf="organizationId !== undefined && organizationId !== null && showReportButton()"
            routerLink="/organizations/{{ organizationId }}/report" ngbTooltip="Usage Report" class="ml-4">
            <i class="far fa-chart-line pointer"></i>
          </span>
          <span (click)="editOrg()" *ngIf="!editObj && !deleteObj" class="ml-4" ngbTooltip="Edit">
            <i class="fal fa-pencil-alt pointer"></i>
          </span>
          <span (click)="deleteOrganization()" *ngIf="!editObj && !deleteObj" class="ml-4" ngbTooltip="Delete">
            <i class="fal fa-trash-alt pointer"></i>
          </span>
          <!-- <span (click)="showSwitchParentOrg = !showSwitchParentOrg" *ngIf="!editObj" class="ml-4"
            ngbTooltip="Change Parent">
            <i class="fal fa-users"></i>
          </span> -->
          <span (click)="saveOrganization()" *ngIf="!saving && editObj" ngbTooltip="Save">
            <i class="fal fa-save pointer"></i>
          </span>
          <span (click)="cancelEditObj($event, organization);setNewParentOrg();"
            *ngIf="!saving && editObj && organization.ID" class="ml-4" ngbTooltip="Cancel">
            <i class="fal fa-times pointer"></i>
          </span>
          <span *ngIf="deleteObj || (saving && editObj)">
            <i class="fal fa-spinner fa-spin"></i>
          </span>
        </div>
      </div>
    </div>

    <div class="row header my-4">
      <div class="col-md-3">
        <div class="detail-name">Org Code</div>
        <div class="detail-value">{{organization.LoginCode}}</div>
      </div>
    </div>

    <div class="row header my-4" *ngIf="organization.Class && !editObj">
      <div class="col-md-3">
        <div class="detail-name">Course</div>
        <div class="detail-value">{{ organization.Class.CourseCode }}</div>
      </div>
      <div class="col-md-3">
        <div class="detail-name">Class Code</div>
        <div class="detail-value">{{ organization.Class.LoginCode }}</div>
      </div>
      <div class="col-md-3">
        <div class="detail-name">Start</div>
        <div class="detail-value">{{ organization.Class.StartingOn | date }}</div>
      </div>
      <div class="col-md-3">
        <div class="detail-name">End</div>
        <div class="detail-value">{{ organization.Class.Ending | date }}</div>
      </div>
    </div>

    <app-loading-spinner *ngIf="!subOrgs && editObj !== organization"></app-loading-spinner>

    <ng-container *ngIf="subOrgs">

      <div *ngIf="!editObj" class="tabbar d-flex justify-content-between">
        <div>
          <button *ngIf="!isSchool()" class="btn btn-filter mr-2"
            [ngClass]="showingPage === Page.SubOrgs ? (hasSubOrgs() ? 'btn-selected' : 'btn-selected-dashed') : (hasSubOrgs() ? 'btn-light-outlined' : 'btn-light-dashed')"
            (click)="switchTab(Page.SubOrgs)">
            <i class="fas fa-sitemap"></i>
            Suborganizations
          </button>
          <button class="btn btn-filter mr-2"
            [ngClass]="showingPage === Page.Classes ? (hasClasses() ? 'btn-selected' : 'btn-selected-dashed') : (hasClasses() ? 'btn-light-outlined' : 'btn-light-dashed') "
            (click)="switchTab(Page.Classes)">
            <i class="fas fa-graduation-cap"></i>
            Classes
          </button>
          <button class="btn btn-filter mr-2"
            [ngClass]="showingPage === Page.Admins ? (hasAdmins() ? 'btn-selected' : 'btn-selected-dashed') : (hasAdmins() ? 'btn-light-outlined' : 'btn-light-dashed') "
            (click)="switchTab(Page.Admins)">
            <i class="fas fa-shield"></i>
            Staff
          </button>
          <button class="btn btn-filter mr-2"
            *ngIf="hasClasses()"
            [ngClass]="showingPage === Page.Data ? 'btn-selected' : 'btn-light-outlined' "
            (click)="switchTab(Page.Data)">
            <i class="fas fa-chart-bar"></i>
            Data
          </button>
          <button class="btn btn-filter mr-2"
            *ngIf="isInternal()"
            [ngClass]="showingPage === Page.Licenses ? (hasLicenses() ? 'btn-selected' : 'btn-selected-dashed') : (hasLicenses() ? 'btn-light-outlined' : 'btn-light-dashed')"
            (click)="switchTab(Page.Licenses)">
            <i class="fas fa-key"></i>
            Licenses
          </button>
          <!-- <button class="btn btn-filter" [ngClass]="showingPage === Page.Students ? 'btn-selected' : 'btn-light'" (click)="switchTab(Page.Students)">
            <i class="fas fa-user"></i>
            Students
          </button> -->
        </div>

        <div ngbDropdown placement="bottom-right">
          <app-add-or-edit-class-modal (dataRefresh)="getOrganizationDetail()" [parentOrganizationID]="organization.ID"
            [openModalButtonVisible]="showingPage === Page.Classes"></app-add-or-edit-class-modal>
          <app-add-or-edit-org-modal #editOrgModal (dataRefresh)="getOrganizationDetail()"
            [parentOrganizationID]="organization.ID" [openModalButtonVisible]="showingPage === Page.SubOrgs">
          </app-add-or-edit-org-modal>
          <app-add-or-edit-user-modal *ngIf="showingPage === Page.Admins" (dataRefresh)="getOrganizationDetail()"
            [organization]="organization"></app-add-or-edit-user-modal>
        </div>
      </div>

      <div class="mt-4" *ngIf="showingPage === Page.SubOrgs && !editObj">
        <div class="text-nowrap">
          <input class="form-control search-input d-inline"
            (input)="onSearchInput(searchBox.value);queueSearchTerm(searchBox.value)" placeholder="Search" #searchBox
            id="search-box" name="org-search-val">
        </div>
        <!-- <input type="text" placeholder=" Search" [(ngModel)]="terms" (ngModelChange)="filterOrgs()" /> -->
        <app-org-list [orgs]="searchValue ? (listItems$ | async) : subOrgs" [showParent]="!!searchValue"
          [noMatches]="noMatches" [loading]="searching" [showType]="true"></app-org-list>
      </div>

      <div class="mt-4" *ngIf="showingPage === Page.Classes && !editObj">
        <!-- <input type="text" placeholder=" Search" [(ngModel)]="terms" (ngModelChange)="filterOrgs()" /> -->
        <app-class-list [classes]="classes"></app-class-list>
      </div>


      <div class="mt-4" *ngIf="showingPage === Page.Admins && !editObj">
        <app-org-admins-list #orgAdminsListComponent [org]="organization" [acctID]="accountID"
          [permissions]="organization.Permissions"></app-org-admins-list>
      </div>

      <div class="mt-4" *ngIf="showingPage === Page.Data && !editObj">
        <app-organization-data [organizationId]="organizationId"></app-organization-data>
      </div>

      <div class="mt-4" *ngIf="showingPage === Page.Licenses && !editObj">
        <app-org-license-details 
          #orgLicenseDetails
          [organizationId]="organizationId"
          [organizationDescription]="organization.Description"
          (licenseSaved)="onLicenseSaved($event)">
        </app-org-license-details>
      </div>

      <!-- <div class="mt-4" *ngIf="showingPage === Page.Students && !editObj">
        Put students here when the API supports requesting all students at an org
      </div> -->

    </ng-container>

  </ng-template>
</app-page-wrapper>
